import { useLiveData, useService } from '@toeverything/infra';
import type { ReactNode } from 'react';

import { AppSidebarService } from '../../services/app-sidebar';
import {
  navHeaderStyle,
  navHeaderUserSlot,
  navHeaderWorkspaceSlot,
} from '../index.css';
import { SidebarConnectivityStatus } from './sidebar-connectivity-status';
import { SidebarSwitch } from './sidebar-switch';

export interface SidebarHeaderProps {
  workspaceSlot?: ReactNode;
  userSlot?: ReactNode;
}

export const SidebarHeader = ({
  workspaceSlot,
  userSlot,
}: SidebarHeaderProps) => {
  const appSidebarService = useService(AppSidebarService).sidebar;
  const open = useLiveData(appSidebarService.open$);

  return (
    <div className={navHeaderStyle} data-open={open}>
      <SidebarSwitch show={open} />
      {workspaceSlot ? (
        <div className={navHeaderWorkspaceSlot}>{workspaceSlot}</div>
      ) : null}
      {userSlot ? <div className={navHeaderUserSlot}>{userSlot}</div> : null}
      {!workspaceSlot && !userSlot ? (
        <>
          <div className={navHeaderWorkspaceSlot} />
          <SidebarConnectivityStatus />
        </>
      ) : null}
    </div>
  );
};

export * from './sidebar-connectivity-status';
export * from './sidebar-switch';
